export const ADD_EXISTING_BRANCH = "ADD_EXISTING_BRANCH";
export const CREATE_NEW_BRANCH = "CREATE_NEW_BRANCH";